module.exports = __webpack_public_path__ + "img/hr-tank-base-shadow-4.026f579e.png";